// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__22odC","left":"styles_left__1X-xM"};